export default "__VITE_PUBLIC_ASSET__262ab045__"